"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _useOurTranslation = _interopRequireDefault(require("../../utils/useOurTranslation"));

var _ArrowBack = _interopRequireDefault(require("@material-ui/icons/ArrowBack"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Dialog = _interopRequireDefault(require("@material-ui/core/Dialog"));

var _DialogTitle = _interopRequireDefault(require("@material-ui/core/DialogTitle"));

var _DialogContent = _interopRequireDefault(require("@material-ui/core/DialogContent"));

var _DialogActions = _interopRequireDefault(require("@material-ui/core/DialogActions"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _LogoJMM = _interopRequireDefault(require("@jobmatchme/ui/es/components/LogoJMM"));

var _Button = _interopRequireDefault(require("@jobmatchme/ui/es/components/styleguide/Button"));

var _jsxRuntime = require("react/jsx-runtime");

var styles = function styles(theme) {
  return {
    root: {
      margin: 0,
      padding: theme.spacing(2)
    },
    rounded: {
      borderRadius: '16px'
    },
    buttonSpacing: {
      padding: theme.spacing(20)
    },
    closeButton: {
      position: 'absolute',
      // Typescript needs an explicit typecast here to infer the correct type
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500]
    }
  };
};

var NoDataOverlay = function NoDataOverlay(_ref) {
  var open = _ref.open,
      onClose = _ref.onClose,
      onAccept = _ref.onAccept,
      classes = _ref.classes,
      variant = _ref.variant;
  var t = (0, _useOurTranslation.default)("profile-components:NoDataOverlay");
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Dialog.default, {
    "aria-labelledby": "no-data-given",
    open: open,
    maxWidth: "xs",
    PaperProps: {
      className: classes.rounded
    },
    onClose: onAccept,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogTitle.default, {
      disableTypography: true,
      className: classes.root,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoJMM.default, {
          variant: "text",
          size: "150"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogContent.default, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Grid.default, {
        container: true,
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          variant: "h4",
          component: "h2",
          children: variant === 'bc' ? t('headlineBc') : t('headline')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          align: "center",
          children: variant === 'bc' ? t('textBc') : t('text')
        })]
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DialogActions.default, {
      classes: {
        spacing: classes.buttonSpacing
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
        container: true,
        direction: "row",
        justifyContent: "center",
        alignItems: "center",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          onClick: onAccept,
          color: "primary",
          variant: "contained",
          startIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ArrowBack.default, {}),
          round: true,
          flat: true,
          texttransform: "none",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            children: t('button')
          })
        })
      })
    })]
  });
};

var _default = (0, _withStyles.default)(styles)(NoDataOverlay);

exports.default = _default;